import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, spacing } from "@mui/system";

import {
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  CardContent,
  Checkbox,
  CircularProgress,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField as MuiTextField,
  Typography,
  TextField,
  FormControl,
  NativeSelect,
  Input,
  Button,
  Card,
  IconButton,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import validateCertificate from "../../../components/validateCertificate";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const Divider = styled(MuiDivider)(spacing);

function NotaFiscalDadoAcessoNFSE({ nfConfiguration, loadConfig }) {
  let [saving, setSaving] = useState(false);
  let {
    getApi,
    postApi,
    putApi,
    user,
    signUpStep2,
    isBSAccount,
    isInitializedBS,
  } = useAuth();

  const [nfsLoginPref, setNfsLoginPref] = React.useState();
  const [nfsSenhaPref, setNfsSenhaPref] = React.useState();
  const [nfsTokenPref, setNfsTokenPref] = React.useState();

  const [certifiedBase64, setCertifiedBase64] = React.useState(null);
  const [certifiedPass, setCertifiedPass] = React.useState(null);
  const [certifiedData, setCertifiedData] = React.useState({});

  const [btnCertifiedAction, setBtnCertifiedAction] = React.useState(true);

  useEffect(() => {
    if (nfConfiguration) {
      if (nfConfiguration.nfs) {
        if (nfConfiguration.nfs.auth) {
          let certData = nfConfiguration.nfs.auth.find(
            (x) => x.type === 2
          ).data;

          if (certData) {
            setCertifiedData({
              org: certData.cert_org,
              issuer: certData.cert_issuer,
              company: certData.cert_company_name,
              fileName: certData.filename,
              expired_at: certData.cert_expired_at,
            });
            setCertifiedPass(certData.certified_password);
          }

          let loginAuth = nfConfiguration.nfs.auth.find((x) => x.type === 1);
          if (loginAuth) {
            setNfsLoginPref(loginAuth.login);
            setNfsSenhaPref(loginAuth.password);
            setNfsTokenPref(loginAuth.token);
          }
        }
      }
    }
  }, [nfConfiguration]);

  const saveNfsTaxsData = async () => {
    setSaving(true);
    let response = await putApi("/nf/configuration", {
      nfs: {
        access: {
          nfsLoginPref: nfsLoginPref,
          nfsSenhaPref: nfsSenhaPref,
          nfsTokenPref: nfsTokenPref,

          certified_filename: certifiedData ? certifiedData["fileName"] : null,
          certified_password: certifiedPass,
          certified_base64: certifiedBase64,
        },
      },
    });
   
    response_run(response);
  };

  const ExcludeCertFile = async () => {
    if (!window.confirm("Você confirma a exclusão do certificado digital?")) {
      return;
    }
    setSaving(true);
    let response = await putApi("/nf/configuration", {
      nfs: {
        access: {
          delete_certified_base64: true,
        },
      },
    });
    loadConfig();
    setSaving(false);
    alert("Certificado Excluido com sucesso.");
  };

  const handleFileChange = async (event) => {
    setCertifiedBase64(null);
    const file = event.target.files[0];
    if (!file) return;
    try {
      setCertifiedData({});
      const certInfo = await validateCertificate(file, certifiedPass);
      let isValid = false;
      if (certInfo) {
        if (certInfo.issuer) {
          if (
            certInfo.issuer.find((x) => x.type == "O").value == "ICP-Brasil"
          ) {
            isValid = true;
            setCertifiedData({
              org: certInfo.issuer.find((x) => x.type == "O").value,
              issuer: certInfo.issuer.find((x) => x.type == "CN").value,
              company: certInfo.subject.find((x) => x.type == "CN").value,
              fileName: file.name,
              expired_at: certInfo.validity.notAfter,
            });
            setBtnCertifiedAction(true);

            if (new Date() >= new Date(certInfo.validity.notAfter)) {
              alert("O certificado está expirado");
              setBtnCertifiedAction(false);
            }
          }
        }
      }

      if (!isValid) {
        alert("Arquivo não é válido");
        setBtnCertifiedAction(false);
      }

      console.log(certInfo);
    } catch (error) {
      console.error("Erro de validação:", error.message);
      alert(error.message);
    }

    const base64 = await convertToBase64(file);
    setCertifiedBase64(base64);
    //  console.log("Base64:", base64); // Apenas para verificação
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]); // Se quiser só o base64, sem "data:..."
      reader.onerror = (error) => reject(error);
    });
  };

  function response_run(res) {
    if(!res.success){
      if (res['nfs.access.nfsLoginPref']) {
        alert(res['nfs.access.nfsLoginPref'].toString());
      } else if (res['nfs.access.nfsSenhaPref']) {
        alert(res['nfs.access.nfsSenhaPref'].toString());
      } else if (res['nfs.access.nfsTokenPref']) {
        alert(res['nfs.access.nfsTokenPref'].toString());
      } 
      else if (res['nfs.access.certified_filename']) {
        alert(res['nfs.access.certified_filename'].toString());
      } else if (res['nfs.access.certified_base64']) {
        alert(res['nfs.access.certified_base64'].toString());
      } else if (res['nfs.access.certified_password']) {
        alert(res['nfs.access.certified_password'].toString());
      } 
    }else {
      alert("Dados salvos");
      loadConfig();
    }
    setSaving(false);

   
  }
  return (
    <React.Fragment>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Configuração Nota Fiscal de Serviço
        </Typography>
        <Typography gutterBottom variant="caption" sx={{ fontSize: 11 }}>
          Para acessar os serviços, você precisará de uma das seguintes
          credenciais: <p></p>
          {nfConfiguration.nfs.provider.credenciais.includes("certificado") && (
            <React.Fragment>
              <strong>Certificado Digital</strong> A1: Um arquivo digital que
              comprova sua identidade e é utilizado para garantir a segurança
              das transações.<br></br>
            </React.Fragment>
          )}
          {nfConfiguration.nfs.provider.credenciais.includes("login_senha") && (
            <React.Fragment>
              <strong>Usuário e senha</strong>: As informações de login e senha
              fornecidas pela prefeitura.<br></br>
              <strong>Token</strong>: Uma chave única gerada pela prefeitura
              para integração com outros sistemas.Se não houver deixe vazio.
            </React.Fragment>
          )}
        </Typography>
        <Grid container>
          {/* Lado B */}
          <Grid sm={12} md={6} sx={{ marginLeft: 5 }}>
            <Grid
              item
              style={{
                paddingTop: 16,
              }}
            >
              <FormControl fullWidth>
                <FormLabel id="lcertifiedPass" sx={{ fontWeight: "bold" }}>
                  Senha do certificado Digital
                </FormLabel>

                <TextField
                  value={certifiedPass}
                  onChange={(e) => setCertifiedPass(e.target.value)}
                  required
                  aria-labelledby="linscricaomunicipallbl"
                />
              </FormControl>
            </Grid>
            <Grid
              item
              style={{
                paddingTop: 16,
                display: nfConfiguration.nfs.provider.credenciais.includes(
                  "certificado"
                )
                  ? "block"
                  : "none",
              }}
            >
              <FormControl fullWidth>
                <FormLabel id="lbl-ambiente">Certificado Digital</FormLabel>

                <Button
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}
                >
                  Anexar certificado digital
                  <VisuallyHiddenInput
                    type="file"
                    accept=".p12,.pfx"
                    key={certifiedBase64}
                    onChange={handleFileChange}
                  />
                </Button>
              </FormControl>
              <Card sx={{ minWidth: 275, marginTop: 5 }}>
                {certifiedData.org && (
                  <React.Fragment>
                    <Typography variant="caption">
                      <strong>Tipo:</strong>
                      {certifiedData.org} <br />
                      <strong>Certificadora:</strong>
                      {certifiedData.issuer} <br />
                      <strong>Titular:</strong>
                      {certifiedData.company} <br />
                      <strong>Data da Expiração:</strong>
                      {new Date(certifiedData.expired_at).toLocaleDateString(
                        "pt-BR"
                      ) +
                        " " +
                        new Date(certifiedData.expired_at).toLocaleTimeString(
                          "pt-BR"
                        )}{" "}
                      <br />
                      {new Date() >= new Date(certifiedData.expired_at) && (
                        <React.Fragment>
                          <Typography variant="caption" color={"red"}>
                            Certificado Expirado
                          </Typography>
                          <br />
                        </React.Fragment>
                      )}
                    </Typography>
                    <strong>Arquivo:</strong> {certifiedData.fileName}
                    <IconButton
                      aria-label="delete"
                      size="large"
                      onClick={(e) => ExcludeCertFile()}
                    >
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                  </React.Fragment>
                )}
              </Card>
              <Divider my={3} />
            </Grid>
            <Grid
              item
              style={{
                paddingTop: 16,
                display: nfConfiguration.nfs.provider.credenciais.includes(
                  "login_senha"
                )
                  ? "block"
                  : "none",
              }}
            >
              <FormControl fullWidth>
                <FormLabel id="lbl-ambiente">
                  Dados de acesso a prefeitura - (Opcional) Caso esteja
                  utilizando certificado digital.
                </FormLabel>
                <Box
                  component="form"
                  sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
                  noValidate
                  autoComplete="off"
                >
                  <FormControl variant="standard">
                    <InputLabel htmlFor="input-with-icon-adornment">
                      Login
                    </InputLabel>
                    <Input
                      id="input-with-icon-adornment"
                      onChange={(e) => setNfsLoginPref(e.target.value)}
                      value={nfsLoginPref}
                    />
                  </FormControl>
                  <FormControl variant="standard">
                    <InputLabel htmlFor="input-with-icon-adornment">
                      Senha
                    </InputLabel>
                    <Input
                      id="input-with-icon-adornment"
                      onChange={(e) => setNfsSenhaPref(e.target.value)}
                      value={nfsSenhaPref}
                    />
                  </FormControl>
                  <FormControl variant="standard">
                    <InputLabel htmlFor="input-with-icon-adornment">
                      Token (se a prefeitura exigir)
                    </InputLabel>
                    <Input
                      id="input-with-icon-adornment"
                      onChange={(e) => setNfsTokenPref(e.target.value)}
                      value={nfsTokenPref}
                    />
                  </FormControl>
                </Box>
              </FormControl>
            </Grid>

            <Grid container justifyContent="flex-start">
              <Grid item>
                {saving && (
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress />
                  </Box>
                )}
              </Grid>
            </Grid>
            <br />
            <Button
              variant="contained"
              color="primary"
              mt={3}
              onClick={(e) => saveNfsTaxsData()}
              disabled={saving || !btnCertifiedAction}
            >
              Atualizar Dados
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </React.Fragment>
  );
}

export default NotaFiscalDadoAcessoNFSE;
